import useFetchAdditionalTasks from '../../../hooks/clickup/useFetchAdditionalTasks';
import { parseClickupTableDescription } from '../../../utils/clickup/taskUtils';
import DynamicFilter from '../../../components/common/filter/DynamicFilter';
import { extractOceanTaskData } from '../../../utils/clickup/taskUtils';
import { cleanMapCoor } from '../../../utils/helpers/mapCoordinate';
import Sidebar from '../../../components/sidebar/Sidebar';
import NavBar from '../../../components/navbar/NavBar';
import Map from '../../../components/tracking/map/Map';
import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import './oceantracking.css';

const majorMilestones = [
  { label: "Estimated Date of Arrival", key: "estimatedDateOfArrival" },
  { label: "Booked Date", key: "bookedDate" },
  { label: "Sailing Documents", key: "sailingDocument" },
  { label: "ISF", key: "ISF" },
  { label: "Arrival Notice", key: "arrivalNotice" },
  { label: "Customs Cleared", key: "customsCleared" },
];

const downloadFiles = [
  { label: "POD", key: "POD" },
  { label: "Packing List", key: "packingList" },
  { label: "Commercial Invoice", key: "commercialInvoice" },
  { label: "DO", key: "DO" },
];

const filters = [
  { key: "byContainer", label: "Container" },
  { key: "byPO", label: "PO Number" }
];

const OceanTracking = () => {
  const defaultCoordinates = [{ LATITUDE: 40.758701, LONGITUDE: -111.876183 }];
  const [coordinates, setCoordinates] =  useState(defaultCoordinates);
  const [selectValue, setSelectValue] = useState(null);

  const hasCachedData = Boolean(sessionStorage.getItem("gtms-ocean"))
  const { tasks: listData, loadingFull } = useFetchAdditionalTasks(901318236362, null, hasCachedData, Cookies.get('cp-cn'));

  const values = React.useMemo(() => {
    if (listData?.length) return extractOceanTaskData(listData);
    const cached = sessionStorage.getItem("gtms-ocean");
    return cached ? JSON.parse(cached) : [];
  }, [listData]);

  useEffect(() => {
    if (values && Object.keys(values).length > 0) {
      sessionStorage.setItem("gtms-ocean", JSON.stringify(values));
    }
  }, [values]);

  const handleFilterChange = (filterType, option) => {
    const value = values[filterType]?.[option]?.[0] ?? null
    setSelectValue(value)
    const parsed = value?.description && parseClickupTableDescription(value.description, 6);
    if (parsed) {
      const coors = cleanMapCoor(parsed)
      setCoordinates(coors);
    }
  };

  return (
    <div className='Landing'>
      <div className="LandingContainer">
        <NavBar/>
        <Sidebar/>
        <div className="MapPageContent">
          <div className="OceanTrackingTop">
            <div className="OceanTrackingTopColumn">
              <div className="OceanTrackingTitle">
                <h1>Ocean Tracking</h1>
              </div>
            </div>
            <div className="OceanTrackingTopColumn">
              <div className="oceanTrackingETAField">
                <h2>ETA: </h2>
                {selectValue ? (
                  <span>
                    {new Date(Number(selectValue.estimatedDateOfArrival)).toLocaleDateString("en-CA")}
                  </span>) : <span>No Data Available</span>}
              </div>
            </div>
          </div>
          <div className="OceanTrackingMid">
            <div className="OceanTrackingMap">
              <Map coordinates={coordinates}/>
            </div>
            <div className="OceanTrackingSelection">
              <h3>Select Filter:</h3>
                <DynamicFilter filters={filters} values={values} onChange={handleFilterChange} />
            </div>
          </div>
          <div className="OceanTrackingBottom">
            <div className="OceanTrackingColumn">
              <div className="columnTitle">
                <h3>Tracking Status:</h3>
                {coordinates.map((row, inx) => (
                  <div className="oceanTrackingData">
                    <span>{row.DATE}</span>
                    <span>{row['TRACKING STATUS']}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="OceanTrackingColumn">
              <div className="columnTitle">
                <h3>Major Milestones:</h3>
                {majorMilestones.map(({ label, key }) => (
                  <div className="oceanTrackingDataField" key={key}>
                    <h6>{label}:</h6>
                    {selectValue?.[key] ? (
                      <span>
                        {new Date(Number(selectValue[key])).toLocaleDateString("en-CA")}
                      </span>
                    ) : (
                      <span>No Data Available</span>
                    )}
                  </div>
                ))}
              </div>
            </div>
            <div className="OceanTrackingColumn">
              <div className="columnTitle">
                <h3>Download Files:</h3>
                {downloadFiles.map(({ label, key }) => {
                  const files = selectValue?.[key] ?? [];
                  return (
                    <div className="oceanTrackingDataField" key={key}>
                      <h6>{label}:</h6>
                      {files.length > 0 ? (
                        <div className="fileList">
                          {files.map((file, idx) => (
                            <a key={idx} href={file.url} target="_blank" rel="noopener noreferrer">
                              {file.title || `Download File ${idx + 1}`}
                            </a>
                          ))}
                        </div>
                      ) : (
                        <span>No File Available</span>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OceanTracking